import propOr from 'ramda/src/propOr';
import pathOr from 'ramda/src/pathOr';
import identity from 'ramda/src/identity';
import memoizeWith from 'ramda/src/memoizeWith';
import either from 'ramda/src/either';
import propEq from 'ramda/src/propEq';
import filter from 'ramda/src/filter';
import flatten from 'ramda/src/flatten'
import concat from 'ramda/src/concat'
import find from 'ramda/src/find';
import CustomerService from '@services/Customer';

const Address = {
    async getAddressBook () {
        const customer = await CustomerService.getCustomer( {withAddresses: true} );
        return customer.addresses;
    },
    getSuggestedBillingAddress ( addresses ) {
        const primaryAddresses = addresses.filter( addr => addr.primary === true );
        return find( propEq( 'addressType', 'Billing' ) )( primaryAddresses );
    },
    getDedupedAddressList ( target, list ) {
        const addrToString = addr => `${addr.address1} ${addr.address2} ${addr.city} ${addr.state} ${addr.postalCode}`;
        const targetIter = target.map( addr => [addrToString( addr ).toLowerCase(), addr.id] );
        const targetMap = new Map( targetIter );
        const filteredList = list.filter( addr => !targetMap.has( addrToString( addr ).toLowerCase() ) );
        return target.concat( filteredList );
    }
};

const Wallet = {
    async getPaymentMethods () {
        const customer = await CustomerService.getCustomer( {withWallet: true} );
        return concat( customer.creditCard, customer.paymentTerms );
    },

    normalizeWallet ( {creditCards, paymentTerms} ) {
        console.log('NORMALIZE_WALLET')
        const cards = Array.isArray( creditCards ) ? creditCards.map( this.normalizeCreditCard ) : [];
        const terms = Array.isArray( paymentTerms ) ? paymentTerms.map( this.normalizePaymentTerm ) : [];
        return flatten( [cards, terms] );
    },

    // note - extend Payment with paymentMethodType:'creditCard' to distinguish in UI
    normalizeCreditCard ( payment ) {
        payment.paymentMethodType = 'creditCard';
        return payment;
    },

    // note - extend Payment with paymentMethodType:'terms' to distinguish in UI
    normalizePaymentTerm ( payment ) {
        payment.paymentMethodType = 'terms';
        // apply meta data to terms items for <filter> components
        payment.meta = 'Billtrust; bill me; net; pay later; terms; invoice';
        return payment;
    },

    getDefaultPaymentMethod ( paymentMethods = [] ) {
        if ( !paymentMethods ) {
            return null;
        }
        return paymentMethods.find( p => p.primary === true ) ||
            paymentMethods.find( p => p.paymentMethodType === 'creditCard' );
    }
};

// const USER_INFO = parseUserData( window );
const USER_INFO = pathOr( {}, ['upi', 'User', 'info'], window );
const USER = pathOr( {}, ['upi', 'User'], window );

const User = {
    getInfo: () => USER_INFO,

    isLogged: () => propOr( false, 'isLogged', USER_INFO ),

    isTamProxy: () => propOr( false, 'tamProxy', USER_INFO ),

    isReviewModerator: () => propOr( false, 'isReviewModerator', USER_INFO ),

    getSalesChannel: () => propOr( 'dom', 'salesChannel', USER_INFO ),

    getNotifications: () => propOr([], 'notifications', USER),

    getUserName: memoizeWith( identity, function getUserName () {
        const meta = document.head.querySelector( 'meta[name="mUserName"]' );
        return meta ? meta.content : 'unknown';
    } ),

    redirectToLogin ( redirectUrl ) {
        redirectUrl || (redirectUrl = window.location.href);
        const loginUrl = upi.paths.LOGIN_URL.replace( /page=\/[\w+\d+\.\+%-]+&?/, '' );
        window.location = loginUrl + '&redirect=' + redirectUrl;
        return false;
    },

    getCartCount () {
        return parseInt( $( '#cartLink .items' ).text().replace( /[\(\)]/g, '' ) );
    },
    Address,
    Wallet
};

export default User;
